var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quota-message__item"},[_c('div',{staticClass:"quota-message__item-left-wrap"},[_vm._t("left")],2),_c('div',{staticClass:"quota-message__item-right-wrap"},[_vm._t("right")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }